import { render, staticRenderFns } from "./DlgDetailPayloadEachTime.vue?vue&type=template&id=056f2d2a"
import script from "./DlgDetailPayloadEachTime.vue?vue&type=script&lang=js"
export * from "./DlgDetailPayloadEachTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports